/**
 * Defera Zero's Idempotency-Key for one checkout: the same for every click,
 * tab and retry of one user's checkout of one offer, so the server makes one
 * plan for it (8JMIVH got two plans from two clicks 29 seconds apart).
 * Deterministic on purpose: a random key per click is what let the second
 * plan through. The server adds the plan itself (card, total, frequency) to
 * the key it sends Stripe (supabase/functions/_shared/zero-subscription-dedupe.js).
 */
export function zeroCheckoutKey(userId, flightData) {
  const flightKey = flightData?.id || flightData?.offer_id || 'unknown';
  return `zero-${userId}-${flightKey}`.replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 64);
}
